import {
  type getFrontRichiesteIdModuloIdDocumentoConsolidato,
  getGetFrontRichiesteIdModuloIdDocumentoConsolidatoQueryOptions,
} from '@framework/api-client/api/inquiries-compile/richiesta-moduli/richiesta-moduli.ts';
import {
  type apiClientRequest,
  type ErrorType,
} from '@framework/api-client/client/apiClient.ts';
import { type UseQueryOptions } from 'react-query';

export type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Funzione fix per la gestione dei _params_ opzionali nella chiamata
 * getFrontRichiesteIdModuloIdDocumentoConsolidato.
 * Rende la firma uguale per tutte e tre le casistiche dello switch
 */
export function getDocumentoConsolidatoWithoutParamsQueryOptions<
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoConsolidato>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoConsolidato>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
) {
  return getGetFrontRichiesteIdModuloIdDocumentoConsolidatoQueryOptions(
    idRichiesta,
    idRichiestaModulo,
    {},
    options,
  );
}
